import React from 'react'
import Heading from '../../../components/heading'
import Container from 'reactor/components/Grid/ContainerWithWidth'
import './works.scss'

import App1 from 'assets/images/apps/app1.png'
import App2 from 'assets/images/apps/app2.png'
import App3 from 'assets/images/apps/app3.png'
import App4 from 'assets/images/apps/app4.png'
import App5 from 'assets/images/apps/app5.png'
import App6 from 'assets/images/apps/app6.png'

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';


SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);


const apps = [
    {
        image: App1,
        title: 'mafak',
    },
    {
        image: App2,
        title: 'akhder',
    },
    {
        image: App3,
        title: 'mohaned',
    },
    {
        image: App4,
        title: 'coffeeSolutions',
    },
    {
        image: App5,
        title: 'station',
    },
    {
        image: App6,
        title: 'bateekh',
    },
]
export default function AppsWorks() {
    return(
        <div className="apps__works">
            <Container block={"true"}>
                <Heading title="آخر اعمالنا" subtitle="مشاريعنا و شركائنا في النجاح" />

                {/* <Slider {...settings}>
                    {apps.map((app, index) =>(
                        <div key={index} className="apps__works--item">
                            <img src={app.image} alt={app.title} className="img-fluid" />
                        </div>
                    ))}
                </Slider> */}


                <Swiper
                    spaceBetween={10}
                    slidesPerView={3}
                    centeredSlides={true}
                    autoplay
                    loop={true}
                    navigation={true}
                    breakpoints={{
                        // when window width is >= 640px
                        320: {
                          slidesPerView: 1,
                          navigation: false,
                          centeredSlides: false,
                        },
                        // when window width is >= 768px
                        768: {
                          slidesPerView: 3,
                        },
                      }}
                    >
                        {apps.map((app, index) =>(
                        <SwiperSlide key={index} className="apps__works--item">
                            <img src={app.image} alt={app.title} className="img-fluid" />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Container>
        </div>
    )
}